/**
 * Convert value into number.
 */
export function toNumber(number: unknown) {
    let result: number;

    if (typeof number === 'number') {
        result = number;
    } else if (typeof number === 'string') {
        result = number.indexOf('.') > -1 ? parseFloat(number) : parseInt(number, 10);
    } else {
        result = NaN;
    }

    return result;
}

/**
 * Invert provided number.
 */
export function invertNumber(number: unknown) {
    return -1 * toNumber(number);
}
